import { track } from '@vercel/analytics';
import type { NextRouter } from 'next/router';

/**
 * Vercel Analytics tracking utilities for conversion events
 */

export const sendAnalyticsData = (eventName: string, eventProperties?: any) => {
  track(eventName, eventProperties);
};

export const goToPartnerPage = (urlToGoTo: string, isBlog?: boolean) => {
  const url = new URL(urlToGoTo);
  if (isBlog) {
    url.searchParams.set('utm_source', 'blogs');
    url.searchParams.set('utm_medium', 'internal');
  }
  sendAnalyticsData('PARTNER_PAGE_VISITED', { url: url.toString() });
  window.location.href = url.toString();
};

export const removeAnalyticsQueryParams = (router: NextRouter) => {
  const removeList = ['gaClientId', 'gaSessionId'];
  removeList.forEach((param) => delete router.query[param]);
  router.replace(
    {
      pathname: router.pathname,
      query: router.query,
    },
    undefined,
    { shallow: true },
  );
};

export type NavigationDestination =
  | 'contact-us'
  | 'schedule-demo'
  | 'request-quote';

/**
 * Track navigation to conversion pages (contact-us, schedule-demo, request-quote)
 * @param destination - The target page
 * @param buttonText - The text of the button that was clicked
 */
export const trackNavigation = (
  destination: NavigationDestination,
  buttonText: string,
) => {
  const pageUrl = typeof window !== 'undefined' ? window.location.pathname : '';
  track('Navigation', {
    destination,
    buttonText,
    pageUrl,
  });

  // Save referral context for Form Submitted event
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem('formReferral_sourcePage', pageUrl);
    window.sessionStorage.setItem('formReferral_sourceButton', buttonText);
  }
};

/**
 * Track form submissions with email
 * @param formType - Type of form (contactus, demo, requestQuote, etc.)
 * @param email - User's email address
 */
export const trackFormSubmitted = (formType: string, email: string) => {
  let sourcePage = '';
  let sourceButton = '';

  if (typeof window !== 'undefined') {
    sourcePage = window.sessionStorage.getItem('formReferral_sourcePage') ?? '';
    sourceButton =
      window.sessionStorage.getItem('formReferral_sourceButton') ?? '';
    window.sessionStorage.removeItem('formReferral_sourcePage');
    window.sessionStorage.removeItem('formReferral_sourceButton');
  }

  track('Form Submitted', {
    formType,
    email,
    sourcePage,
    sourceButton,
  });
};

/**
 * Track "Get Started for Free" button clicks
 * @param buttonText - The text of the button that was clicked
 */
export const trackGetStartedClicked = (buttonText: string) => {
  const pageUrl = typeof window !== 'undefined' ? window.location.pathname : '';
  track('Get Started Clicked', {
    buttonText,
    pageUrl,
  });
};
